import {audit, filter} from 'rxjs/operators';
import {iif, MonoTypeOperatorFunction, Observable, of} from 'rxjs';

export function auditByBooleanState<T>(filterStateProvider: () => boolean, passthroughObservable: Observable<T>): MonoTypeOperatorFunction<T> {
	return obs$ => obs$.pipe(
		audit(() =>
			iif(
				filterStateProvider,
				of(true),
				passthroughObservable.pipe(
					filter(filterStateProvider),
				),
			),
		),
	);
}
